import { useEffect, useState } from "react";
import useDataBean from "../../../../../../core/services/dataBean/useDataBean";
import { Singleton } from "../../../../../../core/services/Singleton";
import { toast } from "react-toastify";
import { ListMenu } from "../../../../../theme/Component/ListMenu";
import { BasicPage } from "../../../../../theme/Component/BasicPage";
import { BasicTable, MASK_MONEY } from "../../../../../theme/Component/BasicTable";
import { Modal } from "../../../../../theme/Component/Modal";
import { ModalConfirm } from "../../../../../theme/Component/ModalConfirm";
import { _NationalizationProcessItems } from "../../../../../../core/services/dataBean/EntityCatalogVdos";
import { SelectTHConstantsValue } from "../../../../config/Componentes/SelectTHConstantsValue";
import { _single } from "../../../../../../core/services/dataBean/EntityCatalog";
import { InputDate } from "../../../../../theme/Input/InputDate";
import { PaymentMethodSelect } from "../../../../../Talentohumano/PaymentMethod/PaymentMethodSelect";
import { InputMoney } from "../../../../../theme/Input/InputMoney";

interface Props {
    IDNationalizationProcessGeneralInfo: number;
}


export const NationalizationProcessItemsByImportDM = ({ IDNationalizationProcessGeneralInfo }: Props) => {

    const NationalizationProcessItemsByImportDM = useDataBean(_NationalizationProcessItems);
    const single = Singleton.getInstance();
    const [Type, setType] = useState<any>(null);
    const [lista, setLista] = useState<any>([]);
    const [appoGroup, setAppoGroup] = useState<number>(null)
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        getLista();
    }, [IDNationalizationProcessGeneralInfo])

    const getLista = () => {

        NationalizationProcessItemsByImportDM.instance.getNationalizationProcessItemsRender(IDNationalizationProcessGeneralInfo).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                }
            }
        )

    }

    const create = () => {
        NationalizationProcessItemsByImportDM.setBean({
            IDNationalizationProcessGeneralInfo: IDNationalizationProcessGeneralInfo,
            ItemType: NationalizationProcessItemsByImportDM.bean.ItemType,
            State: 1,
            Since: _single.getCurrenDate(),
            IDEmployee: _single.getAccountID()
        });
        setModal({ ...modal, "view": true });
    }
    const deleteItem = () => {
        NationalizationProcessItemsByImportDM.deleteItemVoid(NationalizationProcessItemsByImportDM.bean.IDNationalizationProcessItems).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "view": false });
            }
        )

    }


    const editaItem = () => {
        //console.log(entailment.bean);
        NationalizationProcessItemsByImportDM.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const head = [
        { title: 'ID', property: 'IDNationalizationProcessItems', visible: true },
        // { title: 'Tipo de  Item / Lote', property: 'ItemType', visible: true },
        // { title: 'Consecutivo de registro', property: 'Item', visible: true },
        { title: 'Lote', property: 'LoteNumber', visible: true },
        { title: 'Cantidad', property: 'Quantity', visible: true },
        // { title: 'Fecha Elaboración', property: 'DateDM', visible: true },
        // { title: 'Consecutivo de la declaración', property: 'DeclarationNumberDM', visible: true },
        { title: 'No. Autoadhesivo', property: 'SelfAdhesiveDM', visible: true },
        { title: 'Tipo de Declaración', property: 'DeclarationTypeDM', visible: true },
        { title: 'No.Aceptación de la Declaración', property: 'DeclarationAcceptanceNumberDM', visible: true },
        { title: 'Fecha Aceptación de la Declaración', property: 'DateAcceptanceDeclarationDM', visible: true },
        { title: 'Codigo Deposito Aduanero', property: 'BondedWerehouseDM', visible: true },
        { title: 'Agente de Carga', property: 'CargoManifestDM', visible: true },
        { title: 'Fecha del Manifiesto de Carga', property: 'CargoManifestDateDM', visible: true },
        { title: 'Consecutivo de Guía del Transportador', property: 'TransporDocumentDM', visible: true },
        { title: 'Exportador', property: 'ExporterDM', visible: true },
        { title: 'Modo de Transporte', property: 'TransportModeDM', visible: true },
        // { title: 'Tasa de Cambio', property: 'ExchangeRateDM', visible: true },
        { title: 'Modalidad de Ingreso', property: 'ModalityDM', visible: true },
        { title: 'Tipo de Importación', property: 'ImportTypeDMStr', visible: true },
        // { title: 'Posición Arancelaria', property: 'TariffPositionDM', visible: true },
        { title: 'Forma de Pago', property: 'PaymentMethodDM', visible: true },
        { title: 'Peso Bruto', property: 'GrossWeightDM', visible: true },
        { title: 'Codigo Unidad Comercial', property: 'CommercialUnitIDM', visible: true },
        { title: 'Valor FOB', property: 'FOBValueIDM', visible: true, mask: MASK_MONEY },
        { title: 'Fletes y Seguros', property: 'FreightAndInsuranceDM', visible: true, mask: MASK_MONEY },
        { title: 'CIF Dolares', property: 'CIFDollarValueDM', visible: true, mask: MASK_MONEY },
        { title: 'CIF Pesos Colombianos', property: 'CIFColombianPesosValueDM', visible: true, mask: MASK_MONEY },
        { title: 'No. Licencia', property: 'LicenseDM', visible: true },
        { title: 'Valor Gravámenes Pagados', property: 'ValueOfLeviesPaidDM', visible: true, mask: MASK_MONEY },
        { title: 'Observaciones', property: 'ObservationsDM', visible: true },
        { title: 'Destino Final', property: 'DestinationDM', visible: true },
        // { title: 'Consecutivo Acta de Entrega', property: 'RecordNumberDM', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },

    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: true, icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: true, evento: () => { setModal({ ...modal, "name": `Editar ${NationalizationProcessItemsByImportDM.bean.Name}`, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: true, evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        // <BasicPage titulo="Items">
            <div className="row">
                {/* <div className="col-md-6">
                    <label>Tipo de  Item / Lote</label>
                    <SelectTHConstantsValue code={602} value={Type} onChange={(e: any) => { setType(e) }}></SelectTHConstantsValue>
                </div>
                <div className="col-md-4 mt-4 p-2">
                    <BasicButton icon="ri-send-plane-fill" clase="primary" eventClick={getLista}>Buscar por Item / Lote</BasicButton>
                </div> */}
                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={NationalizationProcessItemsByImportDM.setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem}></BasicTable>
                    <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                        <div className="row">
                            {/* <div className="col-md-12">
                                <label>Tipo de  Item / Lote</label>
                                <SelectTHConstantsValue code={602} value={NationalizationProcessItemsByImportDM.bean.ItemType} onChange={(e: any) => { NationalizationProcessItemsByImportDM.setBean({ ...NationalizationProcessItemsByImportDM.bean, "ItemType": e }) }}></SelectTHConstantsValue>
                            </div> */}
                            {/* <div className="col-md-6">

                                <label>No.Consecutivo de registro item</label>
                                <input type="text" name="Item" className="form-control" value={NationalizationProcessItemsByImportDM.bean.Item} onChange={NationalizationProcessItemsByImportDM.handleChange} />

                            </div> */}
                            {/* <div className="col-md-6">

                                <label>Tasa de Cambio</label>
                                <input type="text" name="ExchangeRateDM" className="form-control" value={NationalizationProcessItemsByImportDM.bean.ExchangeRateDM} onChange={NationalizationProcessItemsByImportDM.handleChange} />

                            </div> */}
                            {/* <div className="col-md-6">

                                <label>No. Lote</label>
                                <input type="text" name="LoteNumber" className="form-control" value={NationalizationProcessItemsByImportDM.bean.LoteNumber} onChange={NationalizationProcessItemsByImportDM.handleChange} />

                            </div>
                            <div className="col-md-6">

                                <label>Cantidad</label>
                                <input type="text" name="Quantity" className="form-control" value={NationalizationProcessItemsByImportDM.bean.Quantity} onChange={NationalizationProcessItemsByImportDM.handleChange} />

                            </div>
                            <div className="col-md-6">
                                <InputDate name="DateDM" label="Fecha de elaboración de la declaración de importación" value={NationalizationProcessItemsByImportDM.bean.DateDM} setDate={(e: any) => { NationalizationProcessItemsByImportDM.setBean({ ...NationalizationProcessItemsByImportDM.bean, "DateDM": e }) }} />
                            </div> */}
                            {/* <div className="col-md-6">

                                <label>Consecutivo de la declaración de la importación</label>
                                <input type="text" name="DeclarationNumberDM" className="form-control" value={NationalizationProcessItemsByImportDM.bean.DeclarationNumberDM} onChange={NationalizationProcessItemsByImportDM.handleChange} />

                            </div> */}
                            <div className="col-md-6">

                                <label>Número del autoadhesivo</label>
                                <input type="text" name="SelfAdhesiveDM" className="form-control" value={NationalizationProcessItemsByImportDM.bean.SelfAdhesiveDM} onChange={NationalizationProcessItemsByImportDM.handleChange} />

                            </div>
                            <div className="col-md-6">

                                <label>Tipo de Declaración</label>
                                <input type="text" name="DeclarationTypeDM" className="form-control" value={NationalizationProcessItemsByImportDM.bean.DeclarationTypeDM} onChange={NationalizationProcessItemsByImportDM.handleChange} />

                            </div>
                            <div className="col-md-6">

                                <label>No. Aceptación de Declaración</label>
                                <input type="text" name="DeclarationAcceptanceNumberDM" className="form-control" value={NationalizationProcessItemsByImportDM.bean.DeclarationAcceptanceNumberDM} onChange={(e: any) => { NationalizationProcessItemsByImportDM.setBean({ ...NationalizationProcessItemsByImportDM.bean, "DeclarationAcceptanceNumberDM": e.target.value }) }} />

                            </div>
                            {/* <div className="col-md-6">
                                <InputDate name="DateAcceptanceDeclarationDM" label="Fecha de Aceptación de la declaración de importación" value={NationalizationProcessItemsByImportDM.bean.DateAcceptanceDeclarationDM} setDate={(e: any) => { NationalizationProcessItemsByImportDM.setBean({ ...NationalizationProcessItemsByImportDM.bean, "DateAcceptanceDeclarationDM": e }) }} />
                            </div> */}
                            <div className="col-md-6">

                                <label>Codigo Asignado al deposito Aduanero</label>
                                <input type="text" name="BondedWerehouseDM" className="form-control" value={NationalizationProcessItemsByImportDM.bean.BondedWerehouseDM} onChange={NationalizationProcessItemsByImportDM.handleChange} />

                            </div>
                            <div className="col-md-6">

                                <label>Manifiesto de carga</label>
                                <input type="text" name="CargoManifestDM" className="form-control" value={NationalizationProcessItemsByImportDM.bean.CargoManifestDM} onChange={NationalizationProcessItemsByImportDM.handleChange} />

                            </div>
                            <div className="col-md-6">
                                <InputDate name="CargoManifestDateDM" label="Fecha de manifiesto de carga" value={NationalizationProcessItemsByImportDM.bean.CargoManifestDateDM} setDate={(e: any) => { NationalizationProcessItemsByImportDM.setBean({ ...NationalizationProcessItemsByImportDM.bean, "CargoManifestDateDM": e }) }} />
                            </div>
                            <div className="col-md-6">

                                <label>Consecutivo / Documento de Transporte</label>
                                <input type="text" name="TransporDocumentDM" className="form-control" value={NationalizationProcessItemsByImportDM.bean.TransporDocumentDM} onChange={NationalizationProcessItemsByImportDM.handleChange} />

                            </div>
                            <div className="col-md-6">
                                <label>Exportador</label>
                                <SelectTHConstantsValue code={604} value={NationalizationProcessItemsByImportDM.bean.ExporterDM} onChange={(e: any) => { NationalizationProcessItemsByImportDM.setBean({ ...NationalizationProcessItemsByImportDM.bean, "ExporterDM": e }) }}></SelectTHConstantsValue>
                            </div>
                            <div className="col-md-6">

                                <label>Modo de Transporte</label>
                                <input type="text" name="TransportModeDM" className="form-control" value={NationalizationProcessItemsByImportDM.bean.TransportModeDM} onChange={NationalizationProcessItemsByImportDM.handleChange} />

                            </div>

                            <div className="col-md-6">

                                <label>Modalidad</label>
                                <input type="text" name="ModalityDM" className="form-control" value={NationalizationProcessItemsByImportDM.bean.ModalityDM} onChange={NationalizationProcessItemsByImportDM.handleChange} />

                            </div>
                            <div className="col-md-6">

                                <label>Tipo de Importación</label>
                                <input type="text" name="ImportTypeDMStr" className="form-control" value={NationalizationProcessItemsByImportDM.bean.ImportTypeDMStr} onChange={(e) => { NationalizationProcessItemsByImportDM.setBean({ ...NationalizationProcessItemsByImportDM.bean, "ImportTypeDMStr": e.target.value }) }} />

                            </div>
                            {/* <div className="col-md-6">

                                <label>Posición Arancelaria</label>
                                <input type="text" name="TariffPositionDM" className="form-control" value={NationalizationProcessItemsByImportDM.bean.TariffPositionDM} onChange={NationalizationProcessItemsByImportDM.handleChange} />

                            </div> */}
                            <div className="col-md-6">
                                <label>Medio o Formas de pago</label>
                                <PaymentMethodSelect idSelector={NationalizationProcessItemsByImportDM.bean.PaymentMethodDM} onChange={(e) => { NationalizationProcessItemsByImportDM.setBean({ ...NationalizationProcessItemsByImportDM.bean, "PaymentMethodDM": e }) }} />

                            </div>
                            <div className="col-md-6">

                                <label>Peso Bruto (KG)</label>
                                <input type="text" name="GrossWeightDM" className="form-control" value={NationalizationProcessItemsByImportDM.bean.GrossWeightDM} onChange={NationalizationProcessItemsByImportDM.handleChange} />

                            </div>
                            <div className="col-md-6">

                                <label>Unidad Comercial</label>
                                <input type="text" name="CommercialUnitIDM" className="form-control" value={NationalizationProcessItemsByImportDM.bean.CommercialUnitIDM} onChange={NationalizationProcessItemsByImportDM.handleChange} />

                            </div>
                            <div className="col-md-6">

                                <InputMoney _label="Valor FOB" _value={NationalizationProcessItemsByImportDM.bean.FOBValueIDM} onChange={(e) => { NationalizationProcessItemsByImportDM.setBean({ ...NationalizationProcessItemsByImportDM.bean, "FOBValueIDM": e }) }} />

                            </div>
                            <div className="col-md-6">

                                <InputMoney _label="Fletes y Seguros" _value={NationalizationProcessItemsByImportDM.bean.FreightAndInsuranceDM} onChange={(e) => { NationalizationProcessItemsByImportDM.setBean({ ...NationalizationProcessItemsByImportDM.bean, "FreightAndInsuranceDM": e }) }} />

                            </div>
                            <div className="col-md-6">

                                <InputMoney _label="Valor CIF en Dolares" _value={NationalizationProcessItemsByImportDM.bean.CIFDollarValueDM} onChange={(e) => { NationalizationProcessItemsByImportDM.setBean({ ...NationalizationProcessItemsByImportDM.bean, "CIFDollarValueDM": e }) }} />

                            </div>
                            <div className="col-md-6">

                                <InputMoney _label="Valor CIF en Pesos" _value={NationalizationProcessItemsByImportDM.bean.CIFColombianPesosValueDM} onChange={(e) => { NationalizationProcessItemsByImportDM.setBean({ ...NationalizationProcessItemsByImportDM.bean, "CIFColombianPesosValueDM": e }) }} />

                            </div>
                            <div className="col-md-6">

                                <label>No. Licencia</label>
                                <input type="text" name="LicenseDM" className="form-control" value={NationalizationProcessItemsByImportDM.bean.LicenseDM} onChange={NationalizationProcessItemsByImportDM.handleChange} />

                            </div>
                            <div className="col-md-6">

                                <InputMoney _label="Valor Gravámenes Pagados" _value={NationalizationProcessItemsByImportDM.bean.ValueOfLeviesPaidDM} onChange={(e) => { NationalizationProcessItemsByImportDM.setBean({ ...NationalizationProcessItemsByImportDM.bean, "ValueOfLeviesPaidDM": e }) }} />

                            </div>
                            <div className="col-md-6">

                                <label>IVA</label>
                                <input type="number" step="0.01" min="0" name="IVADM" className="form-control" value={NationalizationProcessItemsByImportDM.bean.IVADM} onChange={NationalizationProcessItemsByImportDM.handleChange} />

                            </div>
                            <div className="col-md-6">
                                <label>Destino</label>
                                <input type="text" name="DestinationDM" className="form-control" value={NationalizationProcessItemsByImportDM.bean.DestinationDM} onChange={NationalizationProcessItemsByImportDM.handleChange} />
                            </div>
                            <div className="col-md-12">
                                <label>Observaciones de la importación</label>
                                <textarea name="ObservationsDM" className="form-control" value={NationalizationProcessItemsByImportDM.bean.ObservationsDM} onChange={NationalizationProcessItemsByImportDM.handleChange} />
                            </div>
                            {/* <div className="col-md-6">

                                <label>No. Acta</label>
                                <input type="text" name="RecordNumberDM" className="form-control" value={NationalizationProcessItemsByImportDM.bean.RecordNumberDM} onChange={NationalizationProcessItemsByImportDM.handleChange} />

                            </div> */}
                            {/* <div className="col-md-12">
                                <label>Descripción</label>
                                <textarea name="Description" className="form-control" value={NationalizationProcessItemsByImportDM.bean.Description} onChange={NationalizationProcessItemsByImportDM.handleChange} />
                            </div> */}
                        </div>
                    </Modal>
                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item {NationalizationProcessItemsByImportDM.bean.Name}</strong>
                    </ModalConfirm>
                </div>

            </div>
        // </BasicPage>
    )
}